var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedHotspot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_428_64385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.435 82.2761C73.4374 79.388 77.6852 75.357 80.8311 70.5127C83.9771 65.6683 85.9318 60.1482 86.5356 54.4037L50.1339 50.5777L68.435 82.2761Z",
    fill: "#F7C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5299 50.5788C13.5299 44.8026 14.897 39.1084 17.5193 33.9617C20.1417 28.8151 23.9449 24.3621 28.6179 20.967L50.1322 50.5788L13.5299 50.5788Z",
    fill: "#F7C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4348 68.8803C21.3229 73.8827 25.3539 78.1305 30.1983 81.2764C35.0426 84.4224 40.5627 86.3771 46.3073 86.9809L50.1333 50.5792L18.4348 68.8803Z",
    fill: "#F7C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1322 13.9792C55.9084 13.9792 61.6026 15.3462 66.7492 17.9686C71.8959 20.5909 76.3488 24.3941 79.744 29.0671L50.1322 50.5814L50.1322 13.9792Z",
    fill: "#F7C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.398 78.7533C70.8445 76.1861 74.6203 72.6029 77.4167 68.2969C80.2131 63.9908 81.9507 59.084 82.4874 53.9777L50.1303 50.5769L66.398 78.7533Z",
    fill: "#F99393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3687 75.2304C68.2594 72.9841 71.5633 69.8489 74.0101 66.081C76.457 62.3132 77.9774 58.0198 78.447 53.5518L50.1345 50.576L64.3687 75.2304Z",
    fill: "#FB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3317 71.7075C65.6666 69.7821 68.4984 67.0948 70.5957 63.8652C72.693 60.6357 73.9962 56.9556 74.3987 53.1259L50.1309 50.5752L62.3317 71.7075Z",
    fill: "#E83131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5935 50.5783C17.5935 45.4439 18.8086 40.3823 21.1396 35.8075C23.4706 31.2328 26.8512 27.2746 31.005 24.2567L50.1288 50.5783L17.5935 50.5783Z",
    fill: "#F99393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6648 50.5778C21.6648 46.0852 22.728 41.6563 24.7676 37.6534C26.8073 33.6504 29.7653 30.187 33.3999 27.5463L50.1332 50.5778L21.6648 50.5778Z",
    fill: "#FB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7283 50.5773C25.7283 46.7264 26.6397 42.9303 28.3879 39.4992C30.1361 36.0681 32.6716 33.0995 35.7869 30.836L50.1298 50.5773L25.7283 50.5773Z",
    fill: "#E83131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9577 66.8472C24.5249 71.2937 28.108 75.0695 32.4141 77.8659C36.7202 80.6623 41.6269 82.3999 46.7332 82.9366L50.1341 50.5795L21.9577 66.8472Z",
    fill: "#F99393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4805 64.814C27.7268 68.7047 30.8621 72.0086 34.6299 74.4554C38.3977 76.9023 42.6911 78.4227 47.1591 78.8923L50.1349 50.5798L25.4805 64.814Z",
    fill: "#FB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0034 62.7809C30.9288 66.1158 33.6162 68.9477 36.8457 71.045C40.0753 73.1423 43.7554 74.4454 47.5851 74.848L50.1357 50.5802L29.0034 62.7809Z",
    fill: "#E83131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1288 18.0466C55.2632 18.0466 60.3247 19.2617 64.8995 21.5927C69.4743 23.9237 73.4325 27.3043 76.4504 31.4581L50.1288 50.5819L50.1288 18.0466Z",
    fill: "#F99393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1332 22.1101C54.6258 22.1101 59.0546 23.1734 63.0576 25.213C67.0605 27.2526 70.5239 30.2106 73.1646 33.8452L50.1332 50.5785L50.1332 22.1101Z",
    fill: "#FB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1298 26.1775C53.9806 26.1775 57.7767 27.0889 61.2078 28.8371C64.6389 30.5853 67.6075 33.1208 69.871 36.2362L50.1298 50.579L50.1298 26.1775Z",
    fill: "#E83131"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.1362,
    cy: 50.5815,
    r: 18.9956,
    fill: "#E40000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_428_64385",
    x: 7.53125,
    y: 7.98047,
    width: 93.0078,
    height: 93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_428_64385"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_428_64385",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHotspot);
export default __webpack_public_path__ + "static/media/redHotspot.2a775d544ea16adb22cc8f3419e7ec73.svg";
export { ForwardRef as ReactComponent };